export default {
    details:{
        en:'details',
        tc:'更多',
        sc:'更多'
    },
    view_more:{
        en:'view more',
        tc:'查看更多',
        sc:'查看更多'
    },
    book_now:{
        en:'book now',
        tc:'立即預定',
        sc:'立即预定'
    },
}